import { commaListSchema } from "@birdwatch/common";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { VendorMain } from "@/features/office/vendors/list";
import {
  filterSearchFragment,
  notificationSearchFragment,
  withOperators,
} from "@/features/shared/filters-new";
import { maskSearchFragment } from "@/features/shared/route-masking";

const querySchema = z.object({
  search: z.string().optional(),
  ...filterSearchFragment,
  filters: z
    .object({
      accountType: withOperators(z.string().optional()),
      vendorType: withOperators(z.string().optional()),
      statuses: withOperators(commaListSchema),
      categoryIds: withOperators(commaListSchema),
      marketIds: withOperators(commaListSchema),
      certificateStatus: withOperators(commaListSchema),
      serviceAgreementStatus: withOperators(commaListSchema),
      w9FormStatus: withOperators(commaListSchema),
      licenseStatus: withOperators(commaListSchema),
      certificateValidity: withOperators(commaListSchema),
      licenseValidity: withOperators(commaListSchema),
      ...notificationSearchFragment,
    })
    .optional(),
  take: z.coerce.number().optional(),
  skip: z.coerce.number().optional(),
  sort: z.string().optional(),
  vendorId: z.string().optional(),
  vendorTab: z.string().optional(),
  ...maskSearchFragment,
});

export const routeId = "/office/vendors/";
export const Route = createFileRoute("/office/vendors/")({
  component: VendorMain,
  validateSearch: querySchema,
});
